import { useMutation } from '@vue/apollo-composable'
import { graphql } from '@/gql'
import { PER_PAGE_MAXIMUM } from '@/utils/constants'

export const useCreateTimesheet = (timesheetPayload) =>
  useMutation(
    graphql(/* GraphQL */ `
      mutation createTimesheet($input: CreateTimesheetInput!, $first: Int) {
        createTimesheet(input: $input) {
          ...TimesheetFormFragment
        }
      }
    `),
    () => ({
      variables: {
        input: {
          worker: timesheetPayload.value.workerId || '',
          hire: timesheetPayload.value.hireId || '',
          startDate: timesheetPayload.value.startDate,
          endDate: timesheetPayload.value.endDate,
          registrations: timesheetPayload.value.registrations,
        },
        first: PER_PAGE_MAXIMUM,
      },
      clientId: 'publicApi',
    }),
  )
